// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/misc/snow-pattern-front.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/misc/snow-pattern-back.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.snow-lines__front {
  position: absolute;
  bottom: -2rem;
  left: 0;
  height: 116px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 100vw;
  background-repeat: repeat-x;
  background-size: cover;
  z-index: 2;
}
.snow-lines__front--index {
  bottom: -4rem;
}
.snow-lines__front-image {
  position: absolute;
  top: 1rem;
  left: 0;
}
.snow-lines__back {
  position: absolute;
  bottom: 0.5rem;
  left: 0;
  height: 116px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: repeat-x;
  background-size: cover;
  width: 100vw;
  z-index: 0;
}
.snow-lines__back--index {
  bottom: -1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/SnowLines/SnowLines.scss"],"names":[],"mappings":"AAIE;EACE,kBAAA;EACA,aAAA;EACA,OAAA;EACA,aAAA;EACA,yDAAA;EACA,YAAA;EACA,2BAAA;EACA,sBAAA;EACA,UAAA;AAHJ;AAKI;EACE,aAAA;AAHN;AAMI;EACE,kBAAA;EACA,SAAA;EACA,OAAA;AAJN;AAQE;EACE,kBAAA;EACA,cAAA;EACA,OAAA;EACA,aAAA;EACA,yDAAA;EACA,2BAAA;EACA,sBAAA;EACA,YAAA;EACA,UAAA;AANJ;AAQI;EACE,aAAA;AANN","sourcesContent":["@import 'src/styles/variables';\n\n.snow-lines {\n\n  &__front {\n    position: absolute;\n    bottom: -2rem;\n    left: 0;\n    height: 116px;\n    background-image: url(\"../../../public/misc/snow-pattern-front.svg\");\n    width: 100vw;\n    background-repeat: repeat-x;\n    background-size: cover;\n    z-index: 2;\n\n    &--index {\n      bottom: -4rem;\n    }\n\n    &-image {\n      position: absolute;\n      top: 1rem;\n      left: 0;\n    }\n  }\n\n  &__back {\n    position: absolute;\n    bottom: 0.5rem;\n    left: 0;\n    height: 116px;\n    background-image: url(\"../../../public/misc/snow-pattern-back.svg\");\n    background-repeat: repeat-x;\n    background-size: cover;\n    width: 100vw;\n    z-index: 0;\n\n    &--index {\n      bottom: -1rem;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
